import { useEffect, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import api from 'helpers/api'
import CircleOk from "components/assets/icons/CircleOk"

const Iban = () => {
  const { t } = useTranslation()
  const { lang, token, adhesionId } = useOutletContext()
  const messageSent = useRef(false)

  useEffect(() => {
    const sendMessage = async () => {
      try {
        messageSent.current = true
        await api.post({
          url: `/clients/revival/iban`,
          data: {
            subject: "Changement d’IBAN",
            text: "Message automatique venant du mail de relance d'un impayé",
            adhesionId
          },
          headers: { Authorization: `Bearer ${token}` }
        })
      } catch (error) {
        console.log('error sending message')
      }
    }
    if (messageSent.current === false) sendMessage()
  }, [messageSent, token, adhesionId])


  return(
    <>
      <h1>
        {t(`contract:revival.iban.${lang}.title`)}
        <CircleOk />
      </h1>
      <p>{t(`contract:revival.iban.${lang}.text`)}</p>
    </>
  )
}

export default Iban